import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';

import { LoaderService } from '@services/loader.service';
import { SessionInitService } from '@services/session-init.service';
import { SocketService } from '@services/socket.service';
import { StorageService } from '@services/storage.service';

import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { ToastModule } from 'primeng/toast';

const modules = [RouterOutlet, ToastModule, ProgressSpinnerModule];

@Component({
  selector: 'app-root',
  imports: [...modules],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent implements OnInit, OnDestroy {
  loaderService = inject(LoaderService);
  storageService = inject(StorageService);
  sessionInitService = inject(SessionInitService);
  socketService = inject(SocketService);

  ngOnInit(): void {
    this.storageService.setLanguage();
    this.sessionInitService.initializeSessionIfLoggedIn();
  }

  ngOnDestroy(): void {
    this.sessionInitService.cleanupSession();
  }
}